import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { KgInput, CurrencyInput, CurrencyDisplay, KgDisplay } from "../../../Utils/Inputs";

export default function SolidosTableRow(props) {
    const { rowName, rowIndex, month, monthIndex, isFirstTable } = props;

    const { control } = useFormContext();

    const kgSecos = useWatch({
        control,
        name: `ComparativoCostoMP.SolidosData.${rowName}.${month}.KgSecos`,
    })
    const costoKgSec = useWatch({
        control,
        name: `ComparativoCostoMP.SolidosData.${rowName}.${month}.CostoKgSec`,
    });
    const total = (kgSecos * costoKgSec).toFixed(2);

    // CASOS ESPECIALES
    // INVENTARIO INICIAL PARA MESES POSTERIORES A ENERO
    if (!isFirstTable && rowName === 'InventarioInicial') {
        return (
            <tr key={rowIndex}>
                <td><KgDisplay value={kgSecos} /></td>
                <td><CurrencyDisplay value={costoKgSec} decimalScale={5} /></td>
                <td><CurrencyDisplay value={total} /></td>
            </tr>
        )
    }

    // SKIM PARA SÓLIDOS - Solo lectura (se obtiene del Comparativo de Costo de Ventas)
    if (rowName === 'SKIMParaSolidos') {
        return (
            <tr key={rowIndex}>
                <td><KgDisplay value={kgSecos} /></td>
                <td><CurrencyDisplay value={costoKgSec} decimalScale={5} /></td>
                <td><CurrencyDisplay value={total} /></td>
            </tr>
        )
    }

    // (+) Coágulo lavado pilas/centrifugas (B9)
    // (+) Coágulos de trampas (B10)
    // (+) Coágulos centrifugado (B11)
    if (rowName === 'CoaguloLavadoPilasCentrifugas' ||
        rowName === 'CoagulosDeTrampas' ||
        rowName === 'CoagulosCentrifugado') {
        return (
            <tr key={rowIndex}>
                <td><KgDisplay value={rowName === 'CoagulosCentrifugado' ? (kgSecos * (-1)) : kgSecos } /></td>
                <td>
                    <CurrencyInput
                        control={control}
                        name={`ComparativoCostoMP.SolidosData.${rowName}.${month}.CostoKgSec`}
                        decimalScale={5} />
                </td>
                <td><CurrencyDisplay value={total} /></td>
            </tr>
        )
    }

    return (
        <tr key={rowIndex}>
            <td>
                <KgInput
                    control={control}
                    name={`ComparativoCostoMP.SolidosData.${rowName}.${month}.KgSecos`} />
            </td>
            <td>
                <CurrencyInput
                    control={control}
                    name={`ComparativoCostoMP.SolidosData.${rowName}.${month}.CostoKgSec`}
                    decimalScale={5} />
            </td>
            <td><CurrencyDisplay value={total} /></td>
        </tr>
    );
}
